import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import {
  Grid,
  FormControl,
  FormHelperText,
  Alert,
  Snackbar,
} from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers';
import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { dateCommencement } from '../../store/reducers/contribution.reducer';
import { PickersDayProps } from '@mui/x-date-pickers';
import { resolveMandant } from 'src/utils';
dayjs.locale('de');

export default function DefaultDateSelection() {
  const mandant = resolveMandant();
  const [modalOpen, setModalOpen] = useState<number>(0);
  const { commencementDate } = useAppSelector((state) => state.contribution);
  const step = useAppSelector((state) => state.stepper.steps);
  const { isColorBlindMode } = useAppSelector((state) => state.config);
  const initialValue = commencementDate
    ? dayjs(commencementDate)
    : mandant==='hallesche' && dayjs().date() <= 15 ? dayjs().startOf('month'): dayjs().add(1, 'month').startOf('month');

  const [value, setValue] = useState<Dayjs | null>(initialValue);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(dateCommencement(value?.format('YYYY-MM-DD').substring(0, 10)));
  }, [dispatch, value]);

  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        setModalOpen(0);
      }, 5000);
    }
  }, [modalOpen]);

  const handleChange = (newValue: Dayjs | null) => {
    if (newValue) {
      const selectedDateMonth = newValue.month();
      const selectedDateYear = newValue.year();
      const currentDateMonth = dayjs().month();
      const currentDateYear = dayjs().year();
      const diffInMonths = (selectedDateYear - currentDateYear) * 12 + selectedDateMonth - currentDateMonth;

      const selectedDate = newValue.format('YYYY-MM-DD');
      const currentDate = dayjs().format('YYYY-MM-DD');
      if (selectedDate < currentDate) {
        setModalOpen(1);
      } else if ( diffInMonths > 6 )
      {
        setModalOpen(2);
      }
    }
    dispatch(dateCommencement(newValue?.format('YYYY-MM-DD').substring(0, 10)));
    setValue(newValue);
  };

  const handleError = (e: any) => {
    e !== null && dispatch(dateCommencement('Invalid Da'));
  };

  const renderCustomDay = (
    day: Dayjs,
    selectedDays: Dayjs[],
    pickersDayProps: PickersDayProps<Dayjs>
  ) => {
    const { children, ...restProps } = pickersDayProps;
    return (
      <PickersDay
        {...restProps}
        sx={{ fontSize: '13px' }}
        onClick={() => handleChange(day)}
      >
        {children}
      </PickersDay>
    );
  };
  const renderCustomDayColorBlind = (
    day: Dayjs,
    _selectedDays: Array<Dayjs | null>,
    pickersDayProps: PickersDayProps<Dayjs>
  ) => {
    const isSelected = value ? day.isSame(value, 'day') : false;

    return (
      <PickersDay
        {...pickersDayProps}
        disableMargin
        sx={{
          fontSize: '13px',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 10,
            left: '35%',
            width: '30%',
            borderBottom: '1px solid black',
          },
          ...(isSelected && {
            backgroundColor: 'accessibility.button.main !important',
            color: 'accessibility.button.contrastText',
            '&:hover': {
              backgroundColor: 'accessibility.button.main',
            },
          }),
        }}
      />
    );
  };

  return (
    <Grid
      container
      spacing={2}
      paddingTop={2}
      paddingBottom={2}
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={modalOpen > 0}
      >
        <Alert severity="info" sx={{ width: '100%' }}>
          {modalOpen === 1 ? 'Bitte beachten Sie, dass die Rückdatierung eines Antrags nicht bei allen Versicherern möglich ist.' : 
          'Bei den meisten Versicherern kann der Antrag in der Regel bis zu 6 Monate vor dem gewünschten Versicherungsbeginn gestellt werden.'}
        </Alert>
      </Snackbar>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="deDE">
            <DatePicker
              label="Beginn der Versicherung"
              inputFormat="DD.MM.YYYY"
              value={commencementDate}
              onError={handleError}
              onChange={handleChange}
              disabled={step === 2}
              components={{
                OpenPickerIcon:
                  isColorBlindMode && step !== 2
                    ? () => (
                        <img
                          src={`${window.location.origin}/logos/dateIcon.svg`}
                          alt="Date Icon"
                          style={{ width: '24px', height: '24px' }}
                        />
                      )
                    : () => null,
              }}
              renderInput={(params: any) => (
                <TextField
                  id="standard-basic"
                  variant="filled"
                  {...params}
                  // sx={{
                  //   ...(step === 2 &&
                  //     isColorBlindMode && {
                  //       '& .MuiFilledInput-root': {
                  //         backgroundColor: 'transparent',
                  //       },
                  //     }),
                  // }}
                  sx={{
                    ...(isColorBlindMode && {
                      backgroundColor: 'inputFields.bgColor',
                      input: { color: '#000000' },
                      '.MuiInputBase-root': {
                        backgroundColor: 'inputFields.bgColor',
                      },
                      '.MuiSvgIcon-root': { color: '#000000' },
                      label: { color: '#000000' },
                    }),
                    ...(isColorBlindMode &&
                      step === 2 && {
                        '& .MuiFilledInput-root:before': {
                          borderBottom: 'none',
                        },
                        '& .MuiFilledInput-root:after': {
                          borderBottom: 'none',
                        },
                        '& .MuiFilledInput-root': {
                          backgroundColor: 'transparent',
                        },
                      }),
                  }}
                />
              )}
              renderDay={
                isColorBlindMode ? renderCustomDayColorBlind : renderCustomDay
              }
            />
            <FormHelperText>
              {step !== 2 ? 'TT.MM.JJJJ' : '\u00A0'}
            </FormHelperText>
          </LocalizationProvider>
        </FormControl>
      </Grid>
    </Grid>
  );
}
